export default __webpack_public_path__ + "static/media/ringback_tone.81833b4d.wav";